/**
 * Angular Import.
 */
import { Component, Input, Output, EventEmitter } from '@angular/core';

/**
 * Import constants.
 */
import { EVENT_MODAL_TYPE } from './../../constants/app.constants';
/**
 * Event modal.
 */
@Component({
  selector: 'app-event-modal',
  templateUrl: './event-modal.component.html',
  styleUrls: ['./event-modal.component.scss']
})
export class EventModalComponent {

  /**
   * Show modal variable.
   */
  @Input() showModal: boolean;

  /**
   * Modal title.
   */
  @Input() title: string;

  /**
   * Type of modal.
   */
  @Input() modalType: string;

  /**
   * Used to use the modal on current component
   */
  @Input() calling_From: string;

  /**
   * Output function when user close modal.
   */
  @Output() backClicked = new EventEmitter();
  /**
   * event modal type.
   */
  eventModalType = EVENT_MODAL_TYPE;

  /**
   * When user click on close or ESC.
   */
  onHidden(): void {
    this.showModal = false;
    this.backClicked.emit();
  }

}
